module.exports = __webpack_public_path__ + "media/authors/shawna-newman-square-5288e26c.jpg";